export default "__VITE_ASSET__e504ff4c__"